import { createSelector } from "reselect";

const getPharmGKBVariantData = (state) =>
  state.variantResult &&
  state.variantResult.pharmgkb &&
  state.variantResult.pharmgkb[0];

const getPharmGKBGeneData = (state) =>
  __IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]?.pharmgkb
    : state?.variantResult?.pharmgkb;

const getPharmGKBData = (state) => {
  return getPharmGKBVariantData(state);
};

const getPharmGKBDrugs = createSelector(getPharmGKBData, (data) => {
  if (data) {
    const { guidelines, chemical_relations: chemicalRelations } = data;
    const guidelinesDrugs = {};
    const chemicalRelationsDrugs = {};
    const drugs = {};
    const result = {};
    guidelines?.forEach((guideline) => {
      guideline.chemical_relations.forEach((relation) => {
        if (guidelinesDrugs[relation.id]) {
          guidelinesDrugs[relation.id] += 1;
        } else {
          guidelinesDrugs[relation.id] = 1;
        }
        if (drugs[relation.id]) {
          drugs[relation.id] += 1;
        } else {
          drugs[relation.id] = 1;
        }
      });
    });
    chemicalRelations?.forEach((relation) => {
      if (chemicalRelationsDrugs[relation.id]) {
        chemicalRelationsDrugs[relation.id] += 1;
      } else {
        chemicalRelationsDrugs[relation.id] = 1;
      }
      if (drugs[relation.id]) {
        drugs[relation.id] += 1;
      } else {
        drugs[relation.id] = 1;
      }
    });
    result.drugs = Object.keys(drugs).length;
    result.guidelines = guidelines?.length;
    return result;
  }

  return null;
});

const getPharmGKBGeneDrugs = createSelector(getPharmGKBGeneData, (data) => {
  if (data) {
    const { guidelines, chemical_relations: chemicalRelations } = data;
    const guidelinesDrugs = {};
    const chemicalRelationsDrugs = {};
    const drugs = {};
    const result = {};
    guidelines?.forEach((guideline) => {
      guideline.chemical_relations.forEach((relation) => {
        if (guidelinesDrugs[relation.id]) {
          guidelinesDrugs[relation.id] += 1;
        } else {
          guidelinesDrugs[relation.id] = 1;
        }
        if (drugs[relation.id]) {
          drugs[relation.id] += 1;
        } else {
          drugs[relation.id] = 1;
        }
      });
    });
    chemicalRelations?.forEach((relation) => {
      if (chemicalRelationsDrugs[relation.id]) {
        chemicalRelationsDrugs[relation.id] += 1;
      } else {
        chemicalRelationsDrugs[relation.id] = 1;
      }
      if (drugs[relation.id]) {
        drugs[relation.id] += 1;
      } else {
        drugs[relation.id] = 1;
      }
    });
    result.drugs = Object.keys(drugs).length;
    result.guidelines = guidelines?.length;
    return result;
  }

  return null;
});

export {
  getPharmGKBData,
  getPharmGKBVariantData,
  getPharmGKBGeneData,
  getPharmGKBDrugs,
  getPharmGKBGeneDrugs,
};
